export default {
  API_ENDPOINT: `https://vast-fortress-26142.herokuapp.com/api`,
}
